import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = { class: "grid grid-cols-[1fr_auto_1fr] items-center pb-2" }
const _hoisted_3 = { class: "text-center font-semibold" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentOptionsNode = _resolveComponent("ContentOptionsNode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('views.reports.selectContentOptionsPage.subheader')), 1),
      _createElementVNode("button", {
        type: "button",
        class: "justify-self-end text-sm font-semibold text-primary-700 hover:text-primary-800 transition-colors disabled:text-gray-400 disabled:cursor-default",
        disabled: _ctx.allOptionIds.length === 0,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
      }, _toDisplayString(_ctx.allSelected ? _ctx.$t('views.reports.selectContentOptionsPage.deselectAllButtonLabel') : _ctx.$t('views.reports.selectContentOptionsPage.selectAllButtonLabel')), 9, _hoisted_4)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['border-2 h-full overflow-y-auto border-opacity-10 rounded-lg py-2', _ctx.maxHeightClass])
    }, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionTree, (root, index) => {
          return (_openBlock(), _createBlock(_component_ContentOptionsNode, {
            key: root.id,
            option: root,
            level: 0,
            "selected-ids": _ctx.computedState.contentOptionIds,
            "expanded-ids": _ctx.expandedOptionIds,
            "indeterminate-ids": _ctx.indeterminateOptionIds,
            "is-last": index === _ctx.optionTree.length - 1,
            onToggleOption: _ctx.toggleOption,
            onToggleExpand: _ctx.toggleExpandedById
          }, null, 8, ["option", "selected-ids", "expanded-ids", "indeterminate-ids", "is-last", "onToggleOption", "onToggleExpand"]))
        }), 128))
      ])
    ], 2)
  ]))
}